import { useState, useCallback } from 'react';
import { Outlet } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';

import AppNavBar from './AppNavBar';
import DialogUserCheckout from './usercheckout/DialogUserCheckout';
import AppVersionTecnozap from './AppVersionTecnozap';

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
  flexDirection: 'column',
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'hidden',
  minHeight: '100%',
  paddingTop: 5,
  background: theme.palette.background.default,
}));

function AppNavigation() {
  return (
    <RootStyle>
      <DialogUserCheckout />
      {/* <AppNavBar /> */}
      <AppVersionTecnozap />
      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}

export default AppNavigation;
